import script from "./UploadImg.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadImg.vue?vue&type=script&lang=ts&setup=true"

import "./UploadImg.vue?vue&type=style&index=0&id=44dc6530&lang=scss&scoped=true"

import exportComponent from "/root/workspace/Client_OdpJ/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44dc6530"]])

export default __exports__